import { render } from "./IdentityPoint.vue?vue&type=template&id=95ddccb0&scoped=true"
import script from "./IdentityPoint.vue?vue&type=script&lang=js"
export * from "./IdentityPoint.vue?vue&type=script&lang=js"

import "./IdentityPoint.vue?vue&type=style&index=0&id=95ddccb0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95ddccb0"]])

export default __exports__